import {roles} from "../utils/roles";

const operator =['supply-encoding-home', 'supplyinspection' ];
const supervisor= ['supply-encoding-home', 'supplyinspection', 'account','printer'];
const administrator= ['supply-encoding-home', 'supplyinspection', 'account','printer','operator'];
const viewer=['sps-monthlyprice'];
const spsAdministrator = ['sps-account-home','sps-admin','sps-monthlyprice', 'fw-catalog'];
const suppliesBusinessOwner = ['sps-supply-catalog', 'sw-catalog'];
const salesRep= ['sps-account-home', 'sps-monthlyprice']
const hbViewer = ['sps-monthlyprice']
const hbAdministrator = ['sps-monthlyprice','sps-admin','sw-catalog', 'sps-account-home']
const isoOperator = ['sw-download']
const isoSupervisor = ['account','sw-download']
const isoAdministrator = ['account','sw-download','operator']

const checkUserAccess =(role,name) => {
    let authorized = false;
    switch(role){
        case roles.suppliesBusinessOwner:
           authorized= suppliesBusinessOwner.includes(name);
           break;
        case roles.spsAdministrator:
           authorized= spsAdministrator.includes(name);
           break;
        case roles.hbAdministrator:
           authorized= hbAdministrator.includes(name);
           break;
        case roles.hbViewer:
           authorized= hbViewer.includes(name);
           break;
        case roles.rmOperator:
           authorized= isoOperator.includes(name);
           break;
        case roles.rmSupervisor:
           authorized= isoSupervisor.includes(name);
           break;
        case roles.rmAdministrator:
           authorized= isoAdministrator.includes(name);
           break;
        case roles.viewer:
        case roles.pricingAdmin:
            authorized = viewer.includes(name);
            break;
        case roles.salesRep:
            authorized = salesRep.includes(name);
            break;
        case roles.rmOperator:
            authorized = operator.includes(name);
            break;
        case roles.rmSupervisor:
            authorized = supervisor.includes(name);
            break;
        case roles.rmAdministrator:
            authorized = administrator.includes(name);
            break;
        default:
    }
    return authorized;
}
export default checkUserAccess;